import type { CategoriesApi } from "@/v2/api/metadata/categories";
import type { PlayersApi } from "@/v2/api/metadata/players";
import type { SportsApi } from "@/v2/api/metadata/sports";
import type { TeamsApi } from "@/v2/api/metadata/teams";
import type { TournamentsApi } from "@/v2/api/metadata/tournaments";
import type { BackofficeContext } from "@/v2/framework/context/types";
import type { DialogConfig } from "@/v2/framework/dialog/types";
import { readApiData } from "@/v2/api/response";
import { createFeedConfigTab } from "./tabs/feed-config";
import { createFeedMappingTab } from "./tabs/feed-mapping";
import { createLiveTab } from "./tabs/live";
import { createMainTab } from "./tabs/main";
import { createPrematchTab } from "./tabs/prematch";
import { createTranslationsTab } from "./tabs/translations";

export function createEditDialog(options: {
  ctx: BackofficeContext;
  playersApi: PlayersApi;
  sportsApi: SportsApi;
  categoriesApi: CategoriesApi;
  tournamentsApi: TournamentsApi;
  teamsApi: TeamsApi;
}): DialogConfig {
  const { ctx, playersApi, sportsApi, categoriesApi, tournamentsApi, teamsApi } = options;

  return {
    id: "edit-player",
    title: "Edit player",
    layout: {
      type: "popover",
    },
    api: {
      initialValues: async (row) => {
        const response = await playersApi.getSingle(row.id);
        const data = readApiData(response);
        return (data && typeof data === "object" && !Array.isArray(data) ? data : {}) as Record<
          string,
          unknown
        >;
      },
      submit: async () => {},
    },
    structure: {
      type: "tabbed",
      savePerTab: true,
      tabs: [
        createMainTab({ playersApi, sportsApi, categoriesApi, tournamentsApi, teamsApi }),
        createPrematchTab(playersApi),
        createLiveTab(playersApi),
        createTranslationsTab({ ctx, playersApi }),
        createFeedMappingTab(playersApi),
        createFeedConfigTab(playersApi),
      ],
    },
  };
}
